export default __webpack_public_path__ + "static/media/SE10.1dfcae70.png";